import React, { useRef,useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setAdditionalInfo} from '../actions'
import AddInfo from './AddInfo'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function Projects() {
  const resumeAddInfos=useSelector(states=>states.resumeData).addInfo
  const [addInfos,setResumeAddInfos]=useState(()=>{
    return resumeAddInfos
  })
  const dispatch=useDispatch()
  const history = useHistory();
  const [title,reference] = [
    useRef(""),
    useRef("")
  ];
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setAdditionalInfo(addInfos))
    history.push("/preview-details");
  }
  function addAddInfo(e){
    e.preventDefault();
    setResumeAddInfos((prevAddInfos)=>{
      return [...prevAddInfos,{title:title.current.value,reference:reference.current.value}]
    })
  }
  function removeAddInfo(id){
    setResumeAddInfos((prevAddInfos)=>{
      return prevAddInfos.filter((addInfo,index)=>index!==id)
    })
  }
  useEffect(()=>{
    title.current.value=''
    reference.current.value=''
  },[addInfos])
  return (
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <h1><i className="fas fa-info-circle mr-2"></i>Additional Details</h1>
        <form onSubmit={addAddInfo}>
          <input type="text" ref={title} placeholder="Info title eg. 'website', 'git-repo', 'linked-in', 'blog' etc " required />
          <input type="url" ref={reference} placeholder="Reference url eg. 'https://gagnu.co'" required />
          <motion.button variants={linkVariant} whileHover="hover" type="submit">add</motion.button>
        </form>
        <ul>
          {addInfos.map((addInfo,index)=>{
            return (<AddInfo addInfo={addInfo} key={index} id={index} removeAddInfo={removeAddInfo} />)
          })}
        </ul>
        {addInfos==0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>next</motion.button>}
        {addInfos!=0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>save & next</motion.button>}
      </motion.div>
    </motion.div>
  );
}
